import React, { Fragment } from "react";
import CaseStudyBanner from "assets/images/YOOZ-STORIES-BANNER.png";
import ContentWrapper from "components/public-dashboard/components/contentWrapper";
import PageBanner from "components/public-dashboard/components/page_banner";
import PartnersContent from "./content";
import PartnersHeader from "./header";
import useDocumentTitle from "../../../../hooks/useDocumentTitle";

export default function CaseStudies() {
    useDocumentTitle("Case Studies");
  return (
    <Fragment>
      <PageBanner img={CaseStudyBanner} />
      <ContentWrapper>
        <PartnersHeader />
        <PartnersContent />
      </ContentWrapper>
    </Fragment>
  );
}
